import auth from "./auth";
import ativos from "./ativos";
import ativosbase from "./ativosbase";
import benchmarks from "./benchmarks";
import info from "./info";
import notificacoes from "./notificacoes";
import user from "./user";
import status from "./status";
import relatorios from "./relatorios";
import posicoes from "./posicoes";
import entidades from "./entidades";
import entidadesUsuario from "./entidadesUsuario";
import enquadramentos from "./entidadesEnquadramento";
import enquadramentosRegras from "./entidadesEnquadramentoRegras";
import cenarios from "./cenarios";
import convites from "./convites";
import carteiras from "./carteiras";
import indicadores from "./indicadores";
import consultas from "./consultas";
import outputs from "./outputs";
import pessoas from "./pessoas";
import pesquisas from "./pesquisas";
import setores from "./setores";
import conferenciasCustodiantes from "./conferenciasCustodiantes";

const services = {
  auth,
  ativos,
  ativosbase,
  benchmarks,
  info,
  notificacoes,
  status,
  user,
  relatorios,
  posicoes,
  entidades,
  entidadesUsuario,
  cenarios,
  convites,
  carteiras,
  indicadores,
  consultas,
  outputs,
  pessoas,
  setores,
  enquadramentos,
  enquadramentosRegras,
  pesquisas,
  conferenciasCustodiantes,
};

export default services;
